import { ApiHelper } from './apiHelper';

export class SiteApi {
    getSiteSettings(
        domainName,
        country,
        defaultCountry,
        successCallback = null,
        failureCallback = null,
        signal
    ) {
        let query = `?domainName=${encodeURIComponent(domainName)}&country=${country}&defaultcountry=${defaultCountry}`;

        let dataUrl = '/api/site/getsitesettings' + query;
        new ApiHelper().getData(
            dataUrl,
            successCallback,
            failureCallback,
            signal
        );
    }

    loadDowntimeConfiguration(successCallback = null, failureCallback = null) {
        const url = '/api/site/getdowntimeconfig';
        new ApiHelper().getData(url, successCallback, failureCallback);
    }
}
